import React, { memo, useEffect, useMemo } from 'react';

import FormGenerator from '@sharedCR/common/formGenerator';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';

import { LanguagePreferenceV2 as LanguagePreferenceOptions } from 'constants/loanApplication';

import { pagesPropTypes } from '../../../MainContent.constants';

import { getConfig } from './LanguagePreference.config';
import { normalizeForm } from './LanguagePreference.utils';

const LanguagePreference = ({
  changedFields,
  isLoading,
  isSaving,
  form,
  validationErrors,
  validateField,
  handleChange,
  entityId,
  setEntityConfig,
  setForm,
  setInForm,
  disabledPendingChangesHighlight,
  pendingChanges,
}) => {
  const isOtherLanguageSelected =
    form[entityId]?.declarations?.languagePreference?.languagePreference?.value ===
    LanguagePreferenceOptions.OTHER;

  const config = useMemo(
    () =>
      getConfig({
        entityId,
        isOtherLanguageSelected,
      }),
    [entityId, isOtherLanguageSelected],
  );

  useEffect(() => {
    setForm(form => normalizeForm({ form, entityId }));
  }, [config, entityId, setForm]);

  useEffect(() => {
    if (!config) {
      return;
    }

    setEntityConfig(config);
  }, [config, setEntityConfig]);

  return (
    <FormGenerator
      isNestedForm
      changedFields={changedFields}
      config={config}
      disabledPendingChangesHighlight={disabledPendingChangesHighlight}
      form={form}
      formName={FormNames.DECLARATIONS}
      handleChange={handleChange}
      isLoading={isSaving || isLoading}
      numberOfColumns={1}
      pendingChanges={pendingChanges}
      setInForm={setInForm}
      validateField={validateField}
      validationErrors={validationErrors}
    />
  );
};

LanguagePreference.propTypes = pagesPropTypes;

export default memo(LanguagePreference);
